const URL = 'blog-categories'

const blogCategoriesApi = ({ apiClient }) => ({
  list(params) {
    return apiClient.get(URL, {}, params)
  },

  show(id) {
    return apiClient.get(`${URL}/${id}`, {}, {})
  },

  store(payload) {
    return apiClient.post(URL, payload, false, {})
  },

  update(id, payload) {
    return apiClient.put(`${URL}/${id}`, payload, {})
  },

  destroy(id) {
    return apiClient.delete(`${URL}/${id}`)
  },
})

export default blogCategoriesApi
